// src/hooks/usePost.ts
import { useQuery } from "@tanstack/react-query";
import { wpApi } from "../services/wpApi";
import type { Post } from "./usePosts";

export function usePost(slug?: string | undefined) {
  return useQuery<Post | null, Error>({
    queryKey: ["post", slug],
    queryFn: async () => {
      if (!slug) return null;
      const res = await wpApi.get("/wp/v2/posts", {
        params: { slug, _embed: true },
      });
      return (res.data && res.data[0]) || null;
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 10,
  });
}
